import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';
import {Provider} from 'react-redux';

import rootReducer from './reducers';
import configureStore from './store';
import Landing from "./components/Landing";

// Install Raven in production envs
if (process.env.NODE_ENV === 'production') {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}
if (typeof DJ_CONST.SOCIAL_LINKS === 'string') {
    DJ_CONST.SOCIAL_LINKS = JSON.parse(DJ_CONST.SOCIAL_LINKS);
}

// Create Redux store
const store = configureStore(rootReducer);

function init() {
    const elem = document.getElementById("root-container");
    if (!elem) {
        return;
    }

    ReactDOM.render(
        <Provider store={store}>
            <Landing />
        </Provider>,
        elem,
    );
}


export {init}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/main.js